import { isDev, isDebug } from '@/config';
import mockData from '@/mockData';
import axios from 'axios';
console.log('avalon:', isDev);

//const apiUrl = `${isDev ? '//luban.m.qq.com' : '//luban.m.qq.com'}/api/public/vip`;// tmp,临时解决外网访问问题

const apiUrl = `${isDev ? '//luban.sparta.html5.qq.com' : '//luban.m.qq.com'}/api/public/vip`;// tmp,临时解决外网访问问题

const Avalon = {
  /**
 * 获取福利列表
 * 产品:1.手管、2.wifi、3.mifi、4.清理大师、5.游戏管家、6.相册、7.同步
 * 平台:1.Android 2.IOS
 */
  getBonusList (product = 7, platform = 1) {
    if (isDebug) {
      return Promise.resolve(mockData.bonusList.result);
    }
    return new Promise((resolve, reject) => {
      axios
        .post(`${apiUrl}/getBonusList`, { product, platform }).then(res => {
          console.log(res);
          if (res.data.success) {
            resolve(res.data.result);
          } else {
            reject();
          }
        })
        .catch(e => {
          console.log(e);
          reject();
        });
    });
  },
  // 获取具体福利
  getBonus (id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${apiUrl}/getBonus?id=${id}`).then(res => {
          console.log(res);
          if (res.data.success) {
            resolve(res.data.bonus);
          } else {
            reject();
          }
        })
        .catch(e => {
          console.log(e);
          reject();
        });
    });
  },
  /**
   * 获取套餐
   * 产品:1.手管、2.wifi、3.mifi、4.清理大师、5.游戏管家、6.相册、7.同步
   * 渠道:1.安卓终端 2.小程序 3.web 4.安卓h5
   * type:wx:微信,qq:QQ
   * default_source来源
   */
  getVipProds (product = 7, channel_id = 4, type = 'qq', default_source) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${apiUrl}/getVipProds`, { product, channel_id, type, default_source }).then(res => {
          console.log(res);
          if (res.data.success) {
            resolve(res.data.products);
          } else {
            reject();
          }
        })
        .catch(e => {
          console.log(e);
          reject();
        });
    });
  },
  /* 新增支付失败错误码*/
  appAddCode (code, createTime) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${apiUrl}/appAddCode`, { code, createTime }).then(res => {
          resolve(res);
        })
        .catch(e => {
          console.log(e);
          reject();
        });
    });
  },
};

export default Avalon;
